import { Link } from 'gatsby'

const renderLinkType = ({ href, to }: { href?: string; to?: string }) => {
  if (href) return 'a'
  if (to) return Link
  return 'button'
}

export default renderLinkType
